(function () {
  var MQ_DESKTOP = window.matchMedia('(min-width: 750px)');

  function getTextEl(card) {
    return card.querySelector('.topper-use-cases__text');
  }

  function collapseText(textEl) {
    if (!textEl) return;
    textEl.style.maxHeight = '0px';
    textEl.style.opacity = '0';
  }

  function expandText(textEl) {
    if (!textEl) return;
    textEl.style.maxHeight = '0px';
    textEl.style.opacity = '0';
    void textEl.offsetHeight;
    textEl.style.maxHeight = textEl.scrollHeight + 'px';
    textEl.style.opacity = '1';
  }

  function syncDesktopText(root) {
    root.querySelectorAll('[data-use-case-card]').forEach(function (card) {
      var textEl = getTextEl(card);
      if (!textEl) return;

      if (!MQ_DESKTOP.matches) {
        textEl.style.maxHeight = '';
        textEl.style.opacity = '';
        return;
      }

      if (card.classList.contains('is-open')) {
        textEl.style.maxHeight = textEl.scrollHeight + 'px';
        textEl.style.opacity = '1';
      } else {
        collapseText(textEl);
      }
    });
  }

  function setExpanded(card, isOpen) {
    var btn = card.querySelector('[data-use-case-btn]');
    card.classList.toggle('is-open', isOpen);
    
    if (btn) btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function openCard(cards, card) {
    cards.forEach(function (other) {
      var isTarget = other === card;
      setExpanded(other, isTarget);

      if (MQ_DESKTOP.matches) {
        if (isTarget) expandText(getTextEl(other));
        else collapseText(getTextEl(other));
      }
    });
  }

  function closeAll(cards) {
    cards.forEach(function (other) {
      setExpanded(other, false);
      if (MQ_DESKTOP.matches) collapseText(getTextEl(other));
    });
  }

  function initUseCases(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-use-case-card]'));
    if (!cards.length) return;

    syncDesktopText(root);

    cards.forEach(function (card) {
      var btn = card.querySelector('[data-use-case-btn]');
      if (!btn || btn.dataset.useCaseBound) return;
      btn.dataset.useCaseBound = '1';

      btn.addEventListener('click', function () {
        if (card.classList.contains('is-open')) {
          closeAll(cards);
          return;
        }
        openCard(cards, card);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-topper-use-cases]').forEach(initUseCases);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-topper-use-cases]');
    if (root) initUseCases(root);
  });

  MQ_DESKTOP.addEventListener('change', function () {
    document.querySelectorAll('[data-topper-use-cases]').forEach(syncDesktopText);
  });
})();
